import { render, staticRenderFns } from "./ManagerUpdateForm.vue?vue&type=template&id=0645708c&"
import script from "./ManagerUpdateForm.vue?vue&type=script&lang=js&"
export * from "./ManagerUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0645708c')) {
      api.createRecord('0645708c', component.options)
    } else {
      api.reload('0645708c', component.options)
    }
    module.hot.accept("./ManagerUpdateForm.vue?vue&type=template&id=0645708c&", function () {
      api.rerender('0645708c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ManagerUpdateForm.vue"
export default component.exports